import { memo, FC } from 'react';

import s from './ContentsDescription.module.scss';
import { NativeAttrs } from './ContentsDescription.types';

interface Props {
  src: string;
  alt: string;
}

export type ImageAreaProps = NativeAttrs<Props, HTMLDivElement> & Props;

const ImageArea: FC<ImageAreaProps> = ({ src, alt, ...props }) => {
  return (
    <div className={s.description__contents__img} {...props}>
      <img src={src} alt={alt} />
    </div>
  );
};
const MemoImageArea = memo(ImageArea);
export default MemoImageArea;
